import React from "react";
import product1 from "../assets/images/product1.png";
import product2 from "../assets/images/product2.png";
// import { useNavigate } from "react-router-dom";

const Cards = () => {

  // const navigate= useNavigate()
  return (
    <div className="productsContainer res">
      <h1  data-aos="fade-up"
     data-aos-duration="2000">محصولات</h1>

      <div className="products">
        <div className="productContainer">
          <div className="product">
          <a href="https://pakshoma.com/shop/5681/160/id1881productid160nametitlevalueu06ccu062eu0686u0627u0644-u0648-u0641u0631u06ccu0632u0631-u062fu0648u0642u0644u0648langfa" target="blank">

            <img src={product1} alt="product 1" loading="lazy"/>

            <p>
              <span>یخچال و فریزر دوقلو Twin Peaks</span>
              <br />
              RTRA-RTFA901 iw (E2)
            </p>

            <div className="circleContainer">
              <div className="circle" style={{backgroundColor:"white"}}></div>
              سفید
            </div>
            </a>
          </div>
        </div>
     

        <div className="productContainer">
          <div className="product">
          <a href="https://pakshoma.com/shop/5681/171/id3931productid171nametitlevalueu06ccu062eu0686u0627u0644-u0648-u0641u0631u06ccu0632u0631-u062fu0648u0642u0644u0648langfa" target="blank">

            <img src={product2} alt="product 2" loading="lazy"/>

            <p>
              <span>یخچال و فریزر دوقلو Twin Peaks</span>
              <br />
              RTRA-RTFA901 ix (N1)
            </p>
            <div className="circleContainer">
              <div className="circle"></div>
              اینوکس
            </div>

            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cards;
